module.exports = __webpack_public_path__ + "img/Art01-19710261-0656.a9749d32.jpg";